module.exports = __webpack_public_path__ + "img/breeding_recharge.f95146bd.jpeg";